<template>
  <side-bar-page :dataProps="{showUp: true,percentShow: 0}">
    <template slot="content">
      <section class="performers-page">
        <h1>Performers</h1>
        <p class="page-intro">Discover talent for your next show.</p>
        <form class="catalog-search" @submit.prevent="applyFilters()" role="search">
          <label class="sr-only" for="performer-query">Search by name or act</label>
          <input id="performer-query" type="search" class="form-control" placeholder="Search by name or act…" v-model="searchFilter.name">
          <button type="submit" class="btn btn-filter-alt">Search</button>
          <button type="button" class="btn btn-filter-alt mobile-filters" :aria-expanded="String(filtersOpen)" aria-controls="performer-filters" @click="filtersOpen = !filtersOpen">Filters</button>
        </form>
        <div class="catalog-layout">
          <div class="result-block" id="second" :aria-busy="String(!!isSearching)">
            <div v-if="isSearching" role="status">Loading…<spinner-loader color="#a82d38" /></div>
            <p v-else-if="searchError" role="alert">{{searchError}} <button class="btn btn-filter-alt" @click="startSearch(queryArr)">Try again</button></p>
            <p v-else-if="!users.length" class="text-center no-find">{{$t('noFind')}}</p>
            <div v-show="!isSearching && !searchError">
            <article v-for="user in users" :key="user.id" class="performer-card">
              <img v-if="user.avatar" :src="user.avatar" alt="" class="img-avatar" @error="$set(user, 'avatar', null)">
              <span v-else class="avatar-placeholder" aria-hidden="true">{{userInitials(user)}}</span>
              <div class="performer-info">
                <a :href="'/profile/' + user.id"><h2>{{userName(user)}}</h2></a>
                <p v-if="getArtistTypesList(user.artistTypesList)">{{getArtistTypesList(user.artistTypesList)}}</p>
                <p v-else-if="user.userCategory">{{categoryLabel(user.userCategory)}}</p>
                <p class="performer-location" v-if="userLocation(user)">{{userLocation(user)}}</p>
              </div>
              <router-link class="btn btn-filter-alt profile-btn" :to="{name: 'profile', params: {id: user.id}}">View Profile</router-link>
            </article>
            </div>
            <b-pagination v-if="maxPage>1" v-model="currentPage" :total-rows="allSearchCount" :per-page="countPerPageS" size="md" align="center" @input="setPage"/>
          </div>
          <aside class="filter-block" id="performer-filters" :class="{'filters-open': filtersOpen}">
              <div class="user-filter">
                <h2>Filter performers</h2>
                <label for="performance-type">Performance Type</label>
                <select id="performance-type" class="form-control" v-model="selectArtistType" @change="changeSelect(true)" >
                  <option :value="null">All performance types</option>
                  <option v-for="type in getTypes" :value="type" :key="type.type_en">
                    {{ type[`type_${currentLng}`] }}
                  </option>
                </select>
                
                <button type="button" class="filter-section-toggle additional-filters-toggle"
                  :aria-expanded="String(showAdditionalFilters)" aria-controls="additional-filters"
                  @click="showAdditionalFilters = !showAdditionalFilters">
                  More filters
                  <i class="fa fa-props-collapse" :class="showAdditionalFilters ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                </button>
                <b-collapse id="additional-filters" v-model="showAdditionalFilters">
                  <label>{{$t('categories').toUpperCase()}}</label>
                  <select class="form-control" v-model="selectArtistCategories" @change="changeSelect()" >
                    <option :value="null">- {{$t('category')}} -</option>
                    <option v-for="cat in getGategories" :value="cat" :key="cat.name_en">
                      {{ cat[`name_${currentLng}`] }}
                    </option>
                  </select>

                  <label>{{$t('skillsAndStyles').toUpperCase()}}</label>
                  <select class="form-control" v-model="selectArtistSkill" >
                    <option :value="null">- {{$t('skillOrStyle')}} -</option>
                    <option v-for="skill in getSkillsList" :value="skill" :key="skill.skill_en">
                      {{ skill[`skill_${currentLng}`] }}
                    </option>
                  </select>

                  <div class="form-group has-label">
                    <label>
                        {{$t('pr_city')}}
                    </label>
                    <input ref="filterAutocompleteCity" name="autocompleteCity" @input="searchFilter.googlePlaceId = null" class="form-control" :placeholder="$t('pr_placeholder_city')">
                  </div>

                  <div class="form-group has-label" v-if="searchFilter.showUserHeight">
                    <label for="userHeight">
                        {{$t('pr_height_2')}}
                    </label>
                    <input id="userHeight" class="form-control" :placeholder="$t('pr_placeholder_height_2')" v-model="searchFilter.userHeight">
                  </div>

                  <button type="button" @click="showPropsFilter = !showPropsFilter" class="filter-props-collapse filter-section-toggle"
                    :aria-expanded="String(showPropsFilter)" aria-controls="filters">{{$t('s_filters_props')}}
                    <i class="fa fa-chevron-down fa-props-collapse" v-if="!showPropsFilter"></i>
                    <i class="fa fa-chevron-up fa-props-collapse" v-if="showPropsFilter"></i>
                  </button>
                  <b-collapse id="filters" class="mt-2" v-model="showPropsFilter">
                    <div class="form-group has-label">
                      <label>
                          {{$t('s_filters_height')}}
                      </label>
                      <input type="text" class="form-control" :placeholder="$t('s_filters_height')" v-model="searchFilter.height">
                    </div>
                    <div class="form-group has-label">
                      <label>
                          {{$t('s_filters_length')}}
                      </label>
                      <input type="text" class="form-control" :placeholder="$t('s_filters_length')" v-model="searchFilter.len">
                    </div>
                    <div class="form-group has-label">
                      <label>
                          {{$t('s_filters_width')}}
                      </label>
                      <input type="text" class="form-control" :placeholder="$t('s_filters_width')" v-model="searchFilter.width">
                    </div>
                    <div class="form-group has-label">
                      <label>
                          {{$t('s_filters_weight')}}
                      </label>
                      <input type="text" class="form-control" :placeholder="$t('s_filters_weight')" v-model="searchFilter.weight">
                    </div>
                  </b-collapse>

                  <div class="form-group has-label checkbox no-margin">
                    <input type="checkbox" name="onlyWithPhoto" id="onlyWithPhoto" v-model="searchFilter.onlyWithPhoto"/>
                    <label class="form-radio" for="onlyWithPhoto"><span class="settings-radio">{{$t('s_filters_only_with_photo')}}</span></label>
                  </div>

                  <div class="form-group has-label checkbox">
                    <input type="checkbox" name="onlyWithVideo" id="onlyWithVideo" v-model="searchFilter.onlyWithVideo"/>
                    <label class="form-radio" for="onlyWithVideo"><span class="settings-radio">{{$t('s_filters_only_with_video')}}</span></label>
                  </div>
                </b-collapse>

                <div class="filter-actions">
                  <button type="button" class="btn btn-outline-danger btn-filter btn-filter-i" @click="applyFilters()">
                    Apply filters
                  </button>

                  <button type="button" class="btn btn-outline-danger btn-filter btn-filter-alt btn-filter-alt-i" @click="resetFilters()">
                    Reset
                  </button>
                </div>
                
              </div>
          </aside>
        </div>
      </section>
    </template>
  </side-bar-page>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import SideBarPage from '../components/SideBarPage';
  import {USER_SEARCH, USER_AVATAR_LOAD} from "../store/actions/userConst";
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst";
  import SpinnerLoader from 'vue-spinner/src/PulseLoader.vue';

  export default {
    name: 'search',
    data() {
      return {
        users: [],
        cacheAvatars: [],
        // skills: [],
        // artistTypes: [],
        RxLngPointer: null,
        currentPage: 1,
        allSearchCount: 0,
        maxPage: 1,
        filtersOpen: false,
        searchError: null,
        selectArtistType: null,
        selectArtistCategories: null,
        selectArtistSkill: null,
        RxGooglePointer: null,
        searchFilter: { googlePlaceLocales: {}, city: '', country: '', name: null, len: 0, height: 0, width: 0, weight: 0, onlyWithPhoto: false, onlyWithVideo: false },
        queryArr: [],
        showPropsFilter: false,
        showAdditionalFilters: false,
      }
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe();
      this.RxGooglePointer.unsubscribe();
    },
    mounted() {
      this.RxLngPointer = this.RxLng.subscribe(()=> {
        this.updateGooglePlace();
        this.updateGooglePlaceInput();
      });
      this.RxGooglePointer = this.RxGoogle.subscribe(gPlace=>{
        if (gPlace) {
          let filterAutocompleteCity = new gPlace.Autocomplete(this.$refs.filterAutocompleteCity, {types: ['(cities)']});
          filterAutocompleteCity.addListener('place_changed', ()=>{
            let place = filterAutocompleteCity.getPlace();
            this.searchFilter.googlePlaceId = place.place_id;
            // this.searchFilter.city = place.address_components[0].long_name;
            // this.searchFilter.country = place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name;
         });
        }
      });
    },
    created() {
      this.searchFilter.name = '';
      this.queryArr = [];
      this.queryArr.push((this.searchFilter.name || '').trim());
      this.startSearch(this.queryArr);
      this.prepareSEO();
    },
    computed: {
      ...mapGetters(['isMobileResolution','isSearching','currentLng','RxLng','RxGoogle','countPerPageS','getSkills','getArtistTypes']),
      getSkillsList() {
        let allSkill = this.selectArtistCategories ? this.getSkills.filter(skill=>this.selectArtistCategories.skills.indexOf(skill.code)!=-1)
          .sort((a,b)=>a[`skill_${this.currentLng}`].localeCompare(b[`skill_${this.currentLng}`])): null;
        if(allSkill) {
          let myFilter = [].filter(s=>s.artistTypeId===this.selectArtistType.id && s.categories===this.selectArtistCategories.name_en);
          return allSkill.filter(a=>!~myFilter.findIndex(m=>m.skill===a.code))
        } else {
          return allSkill
        }
      },
      getGategories() {
        let data = JSON.parse(JSON.stringify(this.selectArtistType))
        return this.selectArtistType ? data.categories.sort((a,b)=>a[`name_${this.currentLng}`].localeCompare(b[`name_${this.currentLng}`])) : null
      },
      getTypes() {
        let data = JSON.parse(JSON.stringify(this.getArtistTypes))
        return data.sort((a,b)=>a[`type_${this.currentLng}`].localeCompare(b[`type_${this.currentLng}`]))
      },
    },
    methods: {
      ...mapActions([USER_SEARCH,USER_AVATAR_LOAD,GOOGLE_GET_PLACE]),
      setPage() {
        this.startSearch(this.queryArr);
      },
      prepareSEO() {
        let description = `A large base of artists. Use the search to find artists for your show or performance. Register for free and hire employees!`;
        document.querySelector("meta[name='description']").setAttribute('content', description);
        let title = `Performers | Universtage`;
        document.querySelector("title").text = title;
      },
      getArtistTypesList(artistTypesList) {
        let ids = [];
        (artistTypesList || []).forEach(x=>ids.push(x.artistTypeId))
        let res = '' 
        this.getArtistTypes.filter(t=>~ids.indexOf(t.id)).forEach(f=>res=res+f[`type_${this.currentLng}`]+',')
        if(res.length) {
          return res.slice(0,-1)
        } else {
          return res
        }
      },
      userName(user) { return user.teamName || [user.firstName, user.lastName].filter(Boolean).join(' ') || 'Performer'; },
      userInitials(user) { return this.userName(user).split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase(); },
      categoryLabel(category) { return {artist: 'Artist', team: 'Team', agent: 'Agent', employer: 'Employer'}[category] || ''; },
      userLocation(user) { const place = user.googlePlaceLocales && user.googlePlaceLocales[this.currentLng]; return (place && place.formatted_address) || [user.city, user.country].filter(Boolean).join(', '); },
      startSearch(query) {
        this.searchError = null;
        this.USER_SEARCH({directory: true, query: query, skip: (this.currentPage-1)*this.countPerPageS, limit: this.countPerPageS})
          .then(res=>{
            this.users = JSON.parse(JSON.stringify(res.users));
            this.allSearchCount = res.allSearchCount;
            this.maxPage = parseInt(this.allSearchCount/this.countPerPageS) + ((this.allSearchCount % this.countPerPageS)?1:0)
            if(this.maxPage) {
              if(this.currentPage > this.maxPage) {
                this.currentPage = this.maxPage;
              } 
            }
            this.updateGooglePlace()
            this.users.forEach(u => {
              // Обновляем кеш аватарок
              if(!~this.cacheAvatars.findIndex(c=>c.id===u.id)) {
                this.cacheAvatars.push({id: u.id})
              }
            })
            this.cacheAvatars.forEach(c => {
              if(!c.avatar) {
                this.USER_AVATAR_LOAD(c)
                  .then((img)=>{
                    c.avatar = img
                    this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                    this.users.push({})
                    this.users.splice(this.users.length-1,1)
                  })
                  .catch((err)=>console.log(err))
              } else {
                this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                this.users.push({})
                this.users.splice(this.users.length-1,1)
              }
            })
          })
          .catch(() => { this.searchError = 'Unable to load performers. Please try again.'; })
      },
      updateGooglePlace() {
        this.users.forEach(user=>{
          if(user.googlePlace) {
            user.googlePlaceLocales = user.googlePlaceLocales || {}
            if(!user.googlePlaceLocales[this.currentLng]) {
              this.GOOGLE_GET_PLACE({place_id: user.googlePlace, language: this.currentLng, fields: ['formatted_address']})
                .then(place=>{
                  user.googlePlaceLocales[this.currentLng]=place
                  this.users.push({})
                  this.users.splice(this.users.length-1,1)
                })
                .catch(err=>console.log(err))
            }
          }
        })
      },
      updateGooglePlaceInput() {
        if(this.searchFilter && this.searchFilter.googlePlaceId) {
          this.GOOGLE_GET_PLACE({place_id: this.searchFilter.googlePlaceId, language: this.currentLng, fields: ['address_components']})
            .then(place => {
              this.searchFilter.googlePlaceLocales[this.currentLng] = place.address_components[0].long_name + ', ' + place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name;
              this.$refs.filterAutocompleteCity.value = this.searchFilter.googlePlaceLocales[this.currentLng];
            }).catch(err=>console.log(err))
        }
      },
      changeSelect(type) {
        if (type) {
          this.selectArtistCategories = null;
          this.selectArtistSkill = null;
          this.searchFilter.showUserHeight = false;
          this.searchFilter.userHeight = null;
          if (this.selectArtistType && ['Dancer', 'Sportsman', 'Circus artist'].includes(this.selectArtistType.type_en)) {
            this.searchFilter.showUserHeight = true;
          }
        } else {
          if (this.selectArtistCategories) {
            let skills = this.getSkills;
            for(let i = 0, len = skills.length; i < len; i++) {
              if (skills[i].skill_en === 'Various') {
                this.selectArtistSkill = skills[i];
                break;
              }
            }
          } else {
            this.selectArtistSkill = null;
          }
        }
      },
      applyFilters() {
        this.currentPage = 1;
        this.queryArr = [];
        // name - 1
        if (this.searchFilter.name && this.searchFilter.name.length) {
          this.queryArr.push((this.searchFilter.name || '').trim());
        } else {
          this.queryArr.push('');
        }
        // Keep the legacy positional API slot empty; user category is server controlled.
        this.queryArr.push('');
        // artist type - 3
        if (this.selectArtistType && (this.selectArtistType.id !== 'undefined')) {
          this.queryArr.push(this.selectArtistType.id);
        } else {
          this.queryArr.push('');
        }
        // artist category - 4
        if (this.selectArtistCategories && (this.selectArtistCategories.name_en !== 'undefined')) {
          this.queryArr.push(this.selectArtistCategories.name_en);
        } else {
          this.queryArr.push('');
        }
        // artist skill - 5
        if (this.selectArtistSkill && (this.selectArtistSkill.code !== 'undefined')) {
          this.queryArr.push(this.selectArtistSkill.code);
        } else {
          this.queryArr.push('');
        }
        // city - 6
        if (this.searchFilter.googlePlaceId) {
          this.queryArr.push(this.searchFilter.googlePlaceId);
        } else {
          this.queryArr.push('');
        }
        // props - 7
        let propsSizes = { height: null, len: null, width: null, weight: null };
        if (this.searchFilter.height && this.searchFilter.height.length > 0) {
          propsSizes.height = this.searchFilter.height;
        }
        if (this.searchFilter.len && this.searchFilter.len.length > 0) {
          propsSizes.len = this.searchFilter.len;
        }
        if (this.searchFilter.width && this.searchFilter.width.length > 0) {
          propsSizes.width = this.searchFilter.width;
        }
        if (this.searchFilter.weight && this.searchFilter.weight.length > 0) {
          propsSizes.weight = this.searchFilter.weight;
        }
        this.queryArr.push(propsSizes);

        // usersList - 8
        this.queryArr.push(null);

        // onlyWithPhoto - 9
        this.queryArr.push(this.searchFilter.onlyWithPhoto);

        // onlyWithVideo - 10
        this.queryArr.push(this.searchFilter.onlyWithVideo);

        // onlyWithVideo - 11
        this.queryArr.push(this.searchFilter.userHeight);

        this.startSearch(this.queryArr);
      },
      openProfile(id) {
        // this.$router.push({name: 'profile', params: {id: id}});
        window.open('/profile/' + id, '_blank');
      },
      clearQuery() {
        this.searchFilter.name = null;
        this.applyFilters();
      },
      resetFilters() {
        this.currentPage = 1;
        this.queryArr = [];
        this.searchFilter.name = null;
        this.searchFilter.height = null;
        this.searchFilter.len = null;
        this.searchFilter.width = null;
        this.searchFilter.weight = null;
        this.searchFilter.onlyWithPhoto = false;
        this.searchFilter.onlyWithVideo = false;
        this.searchFilter.userHeight = null;
        this.searchFilter.showUserHeight = false;
        this.searchFilter.googlePlaceLocales = {};
        this.searchFilter.city = '';
        this.searchFilter.country = '';
        this.showAdditionalFilters = false;
        this.showPropsFilter = false;
        this.selectArtistType = null;
        this.selectArtistCategories = null;
        this.selectArtistSkill = null;
        this.searchFilter.googlePlaceId = null;
        this.$refs.filterAutocompleteCity.value = null;
        this.startSearch(this.queryArr);
      },
    },
    components: { SideBarPage, SpinnerLoader },
  }
</script>



<style scoped>
.performers-page { max-width: 1280px; margin: 0 auto; padding: 36px 4% 40px; }
h1 { font-size: 28px; margin: 0 0 8px; }
.page-intro { color: #787078; margin-bottom: 24px; }
.catalog-search { display: flex; gap: 8px; max-width: calc(100% - 312px); margin-bottom: 18px; }
.catalog-search input { flex: 1; min-width: 0; }
.catalog-layout { display: grid; grid-template-columns: minmax(0, 1fr) 288px; gap: 24px; align-items: start; }
.result-block { padding: 0; min-width: 0; }
.performer-card { background: #fff; border: 1px solid #e3dedd; border-radius: 8px; padding: 20px; display: flex; gap: 16px; align-items: center; margin-bottom: 12px; }
.performer-info { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.performer-info h2 { font-size: 17px; font-weight: 600; margin: 0 0 6px; color: #242126; }
.performer-info p { margin: 0 0 4px; font-size: 14px; }
.performer-location { color: #787078; }
.img-avatar, .avatar-placeholder { width: 64px; height: 64px; flex-shrink: 0; border: 0; border-radius: 50%; object-fit: cover; }
.avatar-placeholder { display: flex; align-items: center; justify-content: center; background: #efe5e7; color: #a82d38; }
.profile-btn { text-transform: none; font-size: 13px; white-space: nowrap; font-weight: 400; }
.user-filter { background: #fff; border: 1px solid #e3dedd; border-radius: 8px; padding: 20px; height: auto; min-height: 0; }
.user-filter h2 { font-size: 16px; font-weight: 600; margin-bottom: 20px; }
.user-filter label, .filter-section-toggle, .form-group.has-label.checkbox label { text-transform: none; color: #6f656d; }
.user-filter label { display: block; font-size: 13px; margin-bottom: 6px; }
.user-filter select { margin-bottom: 16px; }
.filter-section-toggle { display: block; padding: 0; margin: 12px 0 16px; border: 0; background: transparent; font: inherit; font-size: 14px; text-align: left; cursor: pointer; }
.fa-props-collapse { font-size: 11px; margin-left: 5px; }
.form-group.has-label.checkbox label { display: inline-block; font-size: 18px; }
.settings-radio { font-size: 13px; }
.no-find { margin: 36px 0; }
.filter-actions { display: flex; flex-direction: column; gap: 8px; margin-top: 16px; }
.filter-actions .btn-filter { width: 100%; padding: 9px; text-transform: none; font-weight: 400 !important; }
.filter-actions .btn-filter-i { color: #fff !important; background: #a82d38 !important; }
.filter-actions .btn-filter-alt-i { background: transparent !important; border-color: transparent !important; color: #787078 !important; }
.mobile-filters { display: none; }
@media(max-width: 767px) {
  .performers-page { padding: 24px 16px; }
  .catalog-search { max-width: none; flex-wrap: wrap; }
  .catalog-search input { flex-basis: 100%; }
  .mobile-filters { display: block; }
  .catalog-layout { display: flex; flex-direction: column; gap: 16px; }
  .filter-block { display: none; padding-top: 0; width: 100%; order: 0; }
  .filter-block.filters-open { display: block; }
  .result-block { width: 100%; padding-top: 0; order: 1; }
  .user-filter { border: 1px solid #e3dedd !important; }
  .performer-card { padding: 16px; gap: 12px; flex-wrap: wrap; }
  .img-avatar, .avatar-placeholder { width: 48px; height: 48px; }
  .performer-info { flex: 1 1 calc(100% - 60px); }
  .profile-btn { margin-left: 60px; }
}
</style>
